import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { aiUsageService } from '@/services/control/ai-usage-service';
import type { AIUsageOverview, AIUsageWindow } from '@/types/control/ai-usage';

import { adminQueryKeys } from '@/hooks/admin/query-keys';
import { retryControlApi } from '@/hooks/admin/retry';

/**
 * Estate-wide AI usage with a row per tenant, for a date window.
 *
 * The window goes to the server rather than being applied here: the tenant
 * summary is an all-time roll-up with no time bucketing, so a range cannot be
 * derived from a cached response. An unparseable date or an inverted range is a
 * `400`, which `retryControlApi` correctly does not retry.
 */
export function useAIUsage(
  window?: AIUsageWindow
): UseQueryResult<AIUsageOverview, Error> {
  return useQuery<AIUsageOverview, Error>({
    queryKey: adminQueryKeys.aiUsage(window),
    queryFn: ({ signal }) => aiUsageService.getOverview(window, signal),
    retry: retryControlApi,
  });
}
